import { createGlobalStyle } from 'styled-components/macro';

export const EmojiMartStyles = createGlobalStyle`
  .emoji-mart-title-label {
    display: none;
  }
`;
